import { Option } from '../../../../shared/options/domain/option';
import { CriteriaKey } from '../criteria';

export const documentDBOption: Option<CriteriaKey> = {
  name: 'Amazon DocumentDB',
  description:
    'Amazon DocumentDB (with MongoDB compatibility) is a fully managed native JSON document database that makes it easy and cost effective to operate critical document workloads at virtually any scale without managing infrastructure. Amazon DocumentDB simplifies your architecture by providing built-in security best practices, continuous backups, and native integrations with other AWS services.',
  tags: ['NoSQL', 'JSON Document'],
  documentationLink: 'https://aws.amazon.com/documentdb/',
  criteriaScores: {
    availability: { score: { value: 7 } },
    securityAndCompliance: { score: { value: 2 } },
    performanceAndScalability: { score: { value: 5 } },
    dataConsistency: { score: { value: 4 } },
    dataStructure: { score: { value: 3 } },
    costOptimization: { score: { value: 5 } },
    dataPersistence: { score: { value: 8 } },
  },
};
